<!--
DashboardTeamPanel

Shows the user's accessible teams for the current dashboard role. Owners see
the commercial access-team lens, while team leaders and team members see
their operational memberships.

Permission rules:
- summary.permissions.canViewTeams controls whether the manage link appears.
- dashboardRole only influences the label and fallback copy.

@author Williams Francis <w.francis@nationaldrones.com> | <olawalewilliams9438@gmail.com>
-->
<template>
    <v-card class="workspace-dashboard__team-card" elevation="0" data-home-tour-teams>
        <div class="workspace-dashboard__section-head workspace-dashboard__section-head--compact">
            <div class="workspace-dashboard__section-kicker" :title="panelTitle">{{ panelTitle }}</div>
            <v-btn
                v-if="actionHref"
                variant="text"
                :href="actionHref"
            >
                {{ actionLabel }}
            </v-btn>
        </div>
        <div class="workspace-dashboard__access-team-list">
            <article
                v-for="team in displayTeams"
                :key="team.uuid || team.id || team.name"
                class="workspace-dashboard__access-team-item"
            >
                <span class="workspace-dashboard__team-avatar">{{ teamInitials(team.name) }}</span>
                <div>
                    <h3>{{ team.name }}</h3>
                    <p>{{ memberLabel(team.memberCount) }}</p>
                </div>
            </article>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'DashboardTeamPanel',
    props: {
        summary: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        dashboardRole() {
            return this.summary.dashboardRole || 'none';
        },
        permissions() {
            return this.summary.permissions || {};
        },
        panelTitle() {
            if (this.dashboardRole === 'team_leader') {
                return 'My Teams';
            }
            if (this.dashboardRole === 'team_member') {
                return 'My Teams';
            }
            return 'Access Teams';
        },
        actionHref() {
            return this.permissions.canViewTeams
                ? this.summary.teamPanel?.manageUrl || null
                : null;
        },
        actionLabel() {
            return this.dashboardRole === 'team_member'
                ? 'Open Teams'
                : 'Manage Access';
        },
        displayTeams() {
            const teams =
                this.permissions.canViewBilling
                    ? this.summary.teamPanel?.accessTeams || this.summary.teamPanel?.teams || []
                    : this.summary.teamPanel?.myTeams || this.summary.teamPanel?.teams || [];
            if (teams.length) {
                return teams.slice(0, 2);
            }

            return [
                {
                    name: this.summary.workspace?.name || 'Operations Team',
                    memberCount: this.summary.workspace?.memberCount || 1,
                },
            ];
        },
    },
    methods: {
        memberLabel(count = 0) {
            const safeCount = Number(count || 1);
            return `${safeCount} ${safeCount === 1 ? 'member' : 'members'}`;
        },
        teamInitials(name = '') {
            const words = String(name || 'OT')
                .trim()
                .split(/\s+/)
                .filter(Boolean);

            return words
                .slice(0, 2)
                .map(word => word[0])
                .join('')
                .toUpperCase() || 'OT';
        },
    },
};
</script>
